// The answer to a Discussion or Assignment prompt. A Discussion inside a Parallel reports the Parallel as its widget.
howspace.widgets.onEvent('widget:prompt:created', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    howspace.aiGen.hidePromptTimeoutMessage(widget);

    real.button.reset(widget.find('.prompt-btn'), widget.find('.prompt-container'));

    const promptResponseWrapper = widget.find('.prompt-response-wrapper');
    promptResponseWrapper.removeClass('d-none');
    const promptResult = promptResponseWrapper.find('.prompt-result');
    const headline = '<h1>' + notification.object.result.headline + '</h1>';
    const content = '<div>' + notification.object.result.text + '</div>';
    promptResult.html(headline + content);
    promptResponseWrapper.dataAndAttr('prompt-id', notification.object.prompt.id);
    promptResponseWrapper.find('.feedback-sentiment-btn').removeClass('active');
    howspace.animate(promptResponseWrapper, 'slideDown', 'normal', () => {
        // Clean "overflow: hidden" now that the animation is completed.
        promptResponseWrapper.css('overflow', '');
    });
});
